export default __webpack_public_path__ + "static/media/benefit-3-cf.580fcbd1.svg";